// Fuso horário DA LOJA no client. As páginas setam quando a loja carrega
// (admin: /api/me ou /api/settings; público: /api/catalog, /api/booking,
// /api/pdv) e os helpers de data/promoção leem daqui — assim os call sites
// existentes não precisam receber tz por parâmetro. Default BRT até carregar.
let current = "America/Sao_Paulo";

export function setStoreTimezone(tz: string | null | undefined): void {
  if (typeof tz === "string" && tz.length > 0) current = tz;
}

export function getStoreTimezone(): string {
  return current;
}
